export default __webpack_public_path__ + "static/media/unity-logo-icon.c9e5c466.png";